import React from 'react'
import PropTypes from 'prop-types'

const UsersTableRow = ({ screenName, createdAt }) => (
  <tr>
    <td className='text-left'>{screenName}</td>
    <td className='text-left'>
      {createdAt ? (
        /* istanbul ignore next */ window
          .moment(createdAt)
          .format()
          .replace('T', ' ')
          .slice(0, 16)
      ) : (
        'No created date'
      )}
    </td>
    <td className='text-left' />
    <td className='text-left' />
  </tr>
)

UsersTableRow.displayName = 'UsersTableRow'

UsersTableRow.propTypes = {
  screenName: PropTypes.string.isRequired,
  createdAt: PropTypes.number.isRequired
}

export default UsersTableRow



// WEBPACK FOOTER //
// ./src/pages/admin/users/users-table-row.js